export default __webpack_public_path__ + "static/cover-15-8b2f9db299b384cc742072a06dc4aaba.jpg";